import BlockEditor from './BlockEditor';

// ScriptView is now a thin wrapper around the new BlockEditor.
// All callers continue to pass the same props they always did.
export default function ScriptView(props) {
  return <BlockEditor {...props} />;
}
